import Vue from 'vue';
import Vuex from 'vuex';

import user from "./modules/user";
import problem from "@/store/modules/problem";
import grid from "@/store/modules/grid";
import task from "@/store/modules/task";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        appError: false,
        appMessage: false,
        loading: false,
        primaryRouteGroups: ['auth', 'problemsList', 'taskList'],
        routes: [
            {code: 'problemsList', title: 'Модели', icon: 'mdi-calculator-variant'},
            {code: 'taskList', title: 'Задачи', icon: 'mdi-calculator-variant'},
        ]
    },
    getters: {
        allowedRoutes(state, getters) {
            return state.routes.filter(route => getters.userHasRights(route.code));
        }
    },
    mutations: {
        setLoading(state, newLoadingState) {
            state.loading = newLoadingState;
        },
        setAppError(state, error) {
            state.appError = error;
        },
        setErrorMessage(state, text) {
            state.appMessage = {text, color: 'error'};
        },
        setSuccessMessage(state, text) {
            state.appMessage = {text, color: 'success'};
        },
        setInfoMessage(state, text) {
            state.appMessage = {text, color: 'info'};
        },
    },
    actions: {},
    modules: {
        user,
        problem,
        grid,
        task
    }
})
